module.exports = __webpack_public_path__ + "img/thesis-white.558b6996.svg";